<template>
  <div class="content-center" style="background-color: #CC007A">
    <div class="p-7 flex justify-center items-center">
      <a href="/"><img src="/images/logo.png" /></a>
    </div>
    <div class="pb-7 flex justify-center items-center">
      <div class="flex justify-center items-center bg-white rounded-md shadow overflow-hidden mx-5 max-w-2xl">
        <form @submit.prevent="store">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-full" label="Cognome" />
            <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-full" label="Nome" />
            <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-8 w-full lg:w-full" label="Città" />
            <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-full" label="Email" />
            <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-full" label="Cellulare" />

            <select-input v-model="form.source" :error="form.errors.source" class="pr-6 pb-8 w-full lg:w-1/2" label="Come hai conosciuto StreetStock?">
            <option value="social">Social</option>
            <option value="passaparola">Passaparola</option>
            <option value="di passaggio">Di passaggio</option>
            <option value="volantino">Volantino</option>
            <option value="newsletter">Newsletter</option>
          </select-input>
              <div class="pr-6 pb-8 w-full lg:w-full">
              <input class="mr-1" type="checkbox" name="checkbox" id="checkbox" v-model="form.checkbox" /> Ho letto e accetto i<a class="ml-1" href="termini-condizioni">termini e condizioni</a> e la<a class="ml-1" href="privacy-policy">privacy policy</a>
              <div class="form-error" v-if="form.errors.checkbox">{{ form.errors.checkbox }}</div>
            </div>
          </div>
          <div class="mt-6 px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
            <loading-button :loading="form.processing" class="btn-indigo" type="submit">Invia</loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Street Stock' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  // layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: null,
        last_name: null,
        city: null,
        email: null,
        phone: null,
        checkbox: null,
        source: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('home.store'))
    },
  },
}
</script>
